import { ConfigurationType } from 'data/types';

export function isDuctedDesignConfiguration(
  configuration: Pick<ConfigurationType, 'type'>
): boolean {
  return configuration.type === 'ducted';
}

export function findDuctedDesignConfiguration(
  configurations: ConfigurationType[]
): ConfigurationType | null {
  return configurations.find(isDuctedDesignConfiguration) ?? null;
}
